var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"null"},[_c('img',{staticClass:"img",attrs:{"src":"https://hopemall.oss-cn-hangzhou.aliyuncs.com/suixintao/memberBenefits/null.png"}}),_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }